"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWhatsappUrl = exports.updateReplybarWithPropertyInfo = exports.checkFeatureOverflow = exports.getDistrictFollowState = exports.getBuildingFollowState = exports.detailStateToSearchQueryForDistrict = exports.detailStateToSearchQueryForBuilding = void 0;
var util = require("util");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var effects_1 = require("redux-saga/effects");
var PlaceFollowedApiSaga_1 = require("@/pages/place/sagas/api/PlaceFollowedApiSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
exports.detailStateToSearchQueryForBuilding = function (state) {
    return {
        languageId: state.layout.language.current,
        currencyId: state.layout.currencies.currentCurrencyId,
        listingTypeId: SfilterTypeGroup_1.SfilterType.toListingPurposeType(state.detail.referringType),
        layout: '',
        area: '',
        district: '',
        keyword: state.detail.property.building,
        priceMin: 0,
        priceMax: 0,
        sizeType: '',
        sizeMin: 0,
        sizeMax: 0,
        bedroomMin: 0,
        bedroomMax: 20,
        sortBy: 'qualityscore',
        orderBy: 'desc',
        pageNumber: 1,
        pageSize: 24,
        searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Building,
    };
};
exports.detailStateToSearchQueryForDistrict = function (state) {
    return {
        languageId: state.layout.language.current,
        currencyId: state.layout.currencies.currentCurrencyId,
        listingTypeId: SfilterTypeGroup_1.ListingPurposeType.All,
        layout: '',
        area: '',
        district: "" + state.detail.district.id,
        keyword: '',
        priceMin: 0,
        priceMax: 0,
        sizeType: '',
        sizeMin: 0,
        sizeMax: 0,
        bedroomMin: 0,
        bedroomMax: 20,
        sortBy: 'qualityscore',
        orderBy: 'desc',
        pageNumber: 1,
        pageSize: 24,
        searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.District,
    };
};
exports.getBuildingFollowState = function (placeName, sfilterType) {
    var lang, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(PlaceFollowedApiSaga_1.checkPlaceFollowedApi, placeName, sfilterType, lang)];
            case 2:
                response = _a.sent();
                if (response && response.data && response.data.userSearchSetId) {
                    return [2 /*return*/, response.data.userSearchSetId];
                }
                return [2 /*return*/];
        }
    });
};
exports.getDistrictFollowState = function (id) {
    var lang, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(PlaceFollowedApiSaga_1.checkDistrictFollowedApi, id, SfilterTypeGroup_1.SfilterType.ALL, lang)];
            case 2:
                response = _a.sent();
                if (response && response.data && response.data.userSearchSetId) {
                    return [2 /*return*/, response.data.userSearchSetId];
                }
                return [2 /*return*/];
        }
    });
};
exports.checkFeatureOverflow = function () {
    var scrollHeight, clientHeight;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(1000)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getElementScrollHeight, 'featureblock')];
            case 2:
                scrollHeight = _a.sent();
                if (scrollHeight === null)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.getElementClientHeight, 'featureblock')];
            case 3:
                clientHeight = _a.sent();
                if (clientHeight === null)
                    return [2 /*return*/];
                if (!(scrollHeight > clientHeight)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setFeatureOverflow(true))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(DetailAction_1.default.setFeatureOverflow(false))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
};
exports.updateReplybarWithPropertyInfo = function (replybar, detailState) {
    var url, text, newReplybar;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 1:
                url = _a.sent();
                text = util.format(detailState.t.whatsappText, detailState.property.building, detailState.property.referenceId, url).replace('#', '%23');
                newReplybar = __assign(__assign({}, replybar), { whatsapp: __assign(__assign({}, replybar.whatsapp), { value: "" + replybar.whatsapp.value + text }) });
                return [2 /*return*/, newReplybar];
        }
    });
};
exports.getWhatsappUrl = function (enquire, enquiryId) {
    var lang, propertyUrl, domain, absUrl, ref, text, absUrl2, text2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!enquire.current) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, enquire.current.building, enquire.current.referenceId, enquire.current.type)];
            case 2:
                propertyUrl = _a.sent();
                return [4 /*yield*/, effects_1.select(WindowApi_1.getCurrentDomain)];
            case 3:
                domain = _a.sent();
                absUrl = "" + domain + propertyUrl;
                ref = "" + enquire.current.referenceId + (enquiryId ? "t" + enquiryId : '');
                text = util.format(enquire.t.whatsappTemplate, enquire.current.building, ref, absUrl).replace('#', '%23');
                return [2 /*return*/, "" + enquire.replybar.whatsapp.value + text];
            case 4: return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 5:
                absUrl2 = _a.sent();
                text2 = util.format(enquire.t.whatsappTemplatePlace, enquire.currentEnquireName, absUrl2);
                return [2 /*return*/, "" + enquire.replybar.whatsapp.value + text2];
        }
    });
};
